import React from 'react';
import NodeResolver from 'react-node-resolver';
import { TargetConsumer } from './spotlight-manager';

/**
 * __Spotlight target__
 *
 * Wraps an element, allowing it to be targeted by a spotlight.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/onboarding)
 */
var SpotlightTarget = function SpotlightTarget(_ref) {
  var children = _ref.children,
      name = _ref.name;
  return /*#__PURE__*/React.createElement(TargetConsumer, null, function (targetRef) {
    return targetRef ? /*#__PURE__*/React.createElement(NodeResolver, {
      innerRef: targetRef(name)
    }, children) : children;
  });
};

export default SpotlightTarget;